
export function generateQueryParam(queryValue, customFilterValues) {
    let query = queryValue;
    for (let key in customFilterValues) {
        let filter = window.TENANT_SETTINGS.filters.find(f => f.name === key);
        if (filter.type === 'single-choice' && filter.choices && !filter.query_field) {
            query += (query.length > 0 ? ' AND ' : '') +
                filter.choices.find(c => c.name === customFilterValues[key]).gql_query;
        }
    }
    return query;
}

export function generateExtraParams(customFilterValues) {
    let params = {};
    for (let key in customFilterValues) {
        let filter = window.TENANT_SETTINGS.filters.find(f => f.name === key);
        if (filter.query_field) {
            if (filter.type === 'multiple-choice')
                params[filter.query_field] = customFilterValues[key].join(',');
            else
                params[filter.query_field] = customFilterValues[key];
        }
    }
    return params;
}
